import {Outlet } from 'react-router-dom';
import SecureRoute from '../../Hooks/SecureRoute';
export default function PrivateRoutes() {
    return (
        <SecureRoute>
            <Outlet />
        </SecureRoute>
    );
}
